import {
    Box,
    Container,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../../../component/Header/Header";
import PortalNavbar from "../../../component/PortalNavbar/PortalNavbar";

const useStyles = makeStyles({
    root: {
        width: "85%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    selectedEnquiry: {
        fontWeight: "bold",
    },
});

const contactList = [
    {
        id: "generalEnquiry",
        name: "一般查詢",
        email: "edbinfo@edb.gov.hk ",
        addressTc: "香港灣仔皇后大道東213號胡忠大厦15樓",
        addressEn:
            "15/F, Wu Chung House 213 Queen's Road East Wan Chai, Hong Kong",
        addressSc: "香港湾仔皇后大道东213号胡忠大厦15楼",
        tel: "(852) 2891 0088",
        fax: "(852) 2893 0858",
    },
    {
        id: "PDT",
        name: "學校領導及專業發展組",
        email: "exoslpd@edb.gov.hk",
        addressTc: "香港添馬添美道2號政府總部東翼5樓學校領導及專業發展組",
        addressEn:
            "School Leadership and Professional Development Section 5/F, East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong",
        addressSc: "香港添马添美道2号政府总部东翼5楼学校领导及专业发展组",
        tel: "-",
        fax: "(852) 2834 7350",
    },
    {
        id: "CDI",
        name: "升學及就業輔導組",
        email: "enquiry_cgt@edb.gov.hk",
        addressTc:
            "九龍九龍塘沙福道19號教育局九龍塘教育服務中心東座平台EP05室升學及就業輔導組",
        addressEn:
            "Career Guidance Section EP05, Podium, East Block, Education Bureau Kowloon Tong Education Services Centre, 19 Suffolk Road, Kowloon Tong, Kowloon",
        addressSc:
            "九龙九龙塘沙福道19号教育局九龙塘教育服务中心东座平台EP05室升学及就业辅导组",
        tel: "(852) 3698 4126",
        fax: "(852) 2770 2012",
    },
];

function Enquiry() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const [division, setDivision] = useState("generalEnquiry");
    const [result, setResult] = useState({});

    function findContactItem(division) {
        setResult(contactList.find((x) => x.id === division));
    }
    useEffect(() => {
        findContactItem(division);
    }, [division]);

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.enquiry")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main Box className="main">
                    <Typography
                        variant="subtitle1"
                        style={{ fontWeight: "bold" }}
                        align="center"
                        component="h1"
                    >
                        {t("common.portal.uatNotice")}
                        <br />
                    </Typography>
                    <Paper
                        className={matches ? classes.root : classes.rootMobile}
                        style={{ textAlign: "center", paddingTop: "0.8rem" }}
                    >
                        <InputLabel htmlFor="enquiry">
                            {t("common.selectEnquiry")}
                        </InputLabel>
                        <Select
                            label="enquiry"
                            inputProps={{
                                id: "enquiry",
                            }}
                            defaultValue="generalEnquiry"
                            fullWidth
                            onChange={(e) => setDivision(e.target.value)}
                            classes={{ select: classes.selectedEnquiry }}
                        >
                            <MenuItem value="generalEnquiry">
                                {t("common.generalEnquiry")}
                            </MenuItem>
                            <MenuItem value="ECP">
                                {t("common.categories.ECP")}
                            </MenuItem>
                            <MenuItem value="SE">
                                {t("common.categories.SE")}
                            </MenuItem>
                            <MenuItem value="PDT">
                                {t("common.categories.PDT")}
                            </MenuItem>
                            <MenuItem value="KG">
                                {t("common.categories.KG")}
                            </MenuItem>
                            <MenuItem value="SA">
                                {t("common.categories.SA")}
                            </MenuItem>
                            <MenuItem value="SD">
                                {t("common.categories.SD")}
                            </MenuItem>
                            <MenuItem value="CDI">
                                {t("common.categories.CDI")}
                            </MenuItem>
                        </Select>
                        <TableContainer component={Paper}>
                            <Table arial-label="enquiry contact list">
                                <TableHead className={classes.header}>
                                    <TableRow>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {t("common.email")}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {t("common.address")}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {t("common.telTitle")}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {t("common.fax")}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {result != undefined ? (
                                        <React.Fragment>
                                            <TableRow key={result.id}>
                                                <TableCell align="center">
                                                    <a
                                                        href={`mailto:${result.email}`}
                                                        style={{
                                                            color: "black",
                                                        }}
                                                    >
                                                        {result.email}
                                                    </a>
                                                </TableCell>
                                                <TableCell align="center">
                                                    {i18n.language === "tc"
                                                        ? result.addressTc
                                                        : i18n.language === "sc"
                                                        ? result.addressSc
                                                        : result.addressEn}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {result.tel}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {result.fax}
                                                </TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    ) : null}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </main>
            </Box>
        </Container>
    );
}
export default Enquiry;
